import { render } from "./ActionDropdown.vue?vue&type=template&id=aad8433e&scoped=true"
import script from "./ActionDropdown.vue?vue&type=script&lang=js"
export * from "./ActionDropdown.vue?vue&type=script&lang=js"

import "./ActionDropdown.vue?vue&type=style&index=0&id=aad8433e&scoped=true&lang=css"
import "./ActionDropdown.vue?vue&type=style&index=1&id=aad8433e&lang=scss"

import exportComponent from "/codebuild/output/src723/src/github.com/aqfer/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aad8433e"]])

export default __exports__